import { render } from "./add-bank-modal.html?vue&type=template&id=012bd912&scoped=true&ts=true&external"
import script from "./add-bank-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-bank-modal.ts?vue&type=script&lang=ts&external"

import "./add-bank-modal.scss?vue&type=style&index=0&id=012bd912&scoped=true&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012bd912"]])

export default __exports__